import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { visibleLiveCount } from '../utils/mainLiveChat';

/**
 * Shared title-over-status Live pin: room title above PUBLIC globe LIVE count.
 * Not a Discussion. Callers own rollout and routing.
 *
 * The globe is a card-center anchor (absolute, left 50%), not a flex sibling
 * of PUBLIC and LIVE. Those labels occupy side slots and cannot shift it.
 */
export default class LiveBoardPin extends Component {
  view() {
    const {
      href,
      title,
      count,
      countLabel,
      ariaLabel,
      marker
    } = this.attrs;
    const shownCount = visibleLiveCount(count);
    const row = m("div", {
      className: "FlatRateMainLiveChat-row"
    }, m(Link, {
      className: "FlatRateMainLiveChat-link",
      href: href,
      "aria-label": ariaLabel
    }, m("span", {
      className: "FlatRateMainLiveChat-heading"
    }, m("span", {
      className: "FlatRateMainLiveChat-titleGroup"
    }, m("span", {
      className: "FlatRateMainLiveChat-title"
    }, title), m("i", {
      className: "fas fa-comments FlatRateMainLiveChat-bubbles",
      "aria-hidden": "true"
    }))), m("span", {
      className: "FlatRateMainLiveChat-status",
      "aria-hidden": "true"
    }, m("span", {
      className: "FlatRateMainLiveChat-public"
    }, "PUBLIC"), m("i", {
      className: "fas fa-globe FlatRateMainLiveChat-globe",
      "aria-hidden": "true"
    }), m("span", {
      className: "FlatRateMainLiveChat-live"
    }, m("span", null, "LIVE"), shownCount != null ? m("span", {
      className: "FlatRateMainLiveChat-count",
      "aria-label": countLabel
    }, String(shownCount)) : null))));
    if (marker === 'brand') {
      return m("div", {
        className: "FlatRateMainLiveChat",
        "data-flatrate-brand-live": "true"
      }, row);
    }
    return m("div", {
      className: "FlatRateMainLiveChat",
      "data-flatrate-main-live": "true"
    }, row);
  }
}
flarum.reg.add('flatrate-forum-navigation', 'forum/components/LiveBoardPin', LiveBoardPin);